import React from 'react'
import './Plans.scss'

function Plans() {
  return (
    <div className='planContainer'>
        <div className='containerHeader'>
            <h1>Proxy Plans</h1>
        </div>

        <div className='planGrid'>
          <div className='pricingCard'>
            <h2>Basic Plan</h2>
            <div className='textContainer'>
              <h3 style={{color: '#A8A8A8'}}>Amount</h3>
              <h2>2GB / $40</h2>
            </div>
            <div className='textContainer2'>
              <h3 style={{color: '#A8A8A8'}}>Expiration</h3>
              <h2>March 2nd</h2>
            </div>
          </div>
          <div className='pricingCard'>
            <h2>Basic Plan</h2>
            <div className='textContainer'>
              <h3 style={{color: '#A8A8A8'}}>Amount</h3>
              <h2>2GB / $40</h2>
            </div>
            <div className='textContainer2'>
              <h3 style={{color: '#A8A8A8'}}>Expiration</h3>
              <h2>March 2nd</h2>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Plans